import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { CreateDepotForm } from "./create-depot-form";
import { Button } from "@/components/ui/button";

export function CreateDepotButton() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="default">Create Depot</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Create Depot</DialogTitle>
        </DialogHeader>
        <CreateDepotForm />
      </DialogContent>
    </Dialog>
  );
}
